// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.714 21a1.286 1.286 0 01-1.285-1.286V5.893a.321.321 0 00-.322-.322H4.286a1.286 1.286 0 010-2.571h14.143A2.571 2.571 0 0121 5.571v14.143A1.286 1.286 0 0119.714 21z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;